import React, { useState } from 'react';
import './ChangePassword.scss';
import { Toaster } from 'react-hot-toast';

const ChangePasswordUI = ({
  handleSubmit,
  hideOldPass = false,
}) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [focusedInput, setFocusedInput] = useState(null);

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleBlur = () => {
    setFocusedInput(null);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      setMessage('');

      let values = {
        newPass: newPassword,
        confirmPass: confirmPassword,
      };
      if (!hideOldPass) {
        values.oldPass = oldPassword;
      }
      handleSubmit(values);
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } else {
      setMessage('Passwords do not match.');
    }
  };
  return (
    <div className="change-password" >
      <div className="change-password-main">
        <div className="change-password-container">
          <Toaster position="top-center" reverseOrder={false}></Toaster>
          <h2>{hideOldPass ? 'Reset Password' : 'Change Password'}</h2>
          <form onSubmit={onSubmit}>
            {!hideOldPass && (
              <div className="form-group">
                <label htmlFor="oldPassword">Old Password</label>
                <input
                  type="password"
                  id="oldPassword"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  onFocus={() => handleFocus('oldPassword')}
                  style={{
                    borderColor: focusedInput === 'oldPassword' ? 'red' : 'rgb(99 102 241)',
                  }}
                  onBlur={handleBlur}
                  required
                />
              </div>
            )}
            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                onFocus={() => handleFocus('newPassword')}
                style={{ borderColor: focusedInput === 'newPassword' ? 'red' : 'rgb(99 102 241)' }}
                onBlur={handleBlur}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onFocus={() => handleFocus('confirmPassword')}
                style={{
                  borderColor: focusedInput === 'confirmPassword' ? 'red' : 'rgb(99 102 241)',
                }}
                onBlur={handleBlur}
                required
              />
            </div>
            {message && <p className="message">{message}</p>}

            <div className="password-requirements">
              <h4>Password Requirements:</h4>
              <ul>
                <li>Password should not contain spaces.</li>
                <li>Password should be more than 4 characters long.</li>
                <li>Password should have at least one special character.</li>
              </ul>
            </div>

            <div className="submitbutton">
              <button type="submit">Confirm</button>
            </div>
          </form>
          
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordUI;
